export interface IFlow {
  flow: FLOW_STATE;
  enterFlow?: FLOW_STATE;
}

export enum FLOW_STATE {
  COMFIRM = 'COMFIRM',
  CALCULATE = 'CALCULATE',
  SHELF = 'SHELF',
  CLEAR = 'CLEAR',
}
